(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["christmas-edit"] && !Shopify.designMode) return;
  try {
    
function initNoel(){document.querySelectorAll('.noel').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.removeAttribute('data-wait');observer.unobserve(entry.target)}})},{threshold:.08});root.querySelectorAll('.noel-reveal').forEach(el=>{el.setAttribute('data-wait','');observer.observe(el)})})}initNoel();document.addEventListener('shopify:section:load',initNoel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["textilfix-premium"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('textilfix-landing')) {
  customElements.define('textilfix-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const image = this.querySelector('.tf-main-image');
      const changeImage = (url) => {
        if (!image || !url) return;
        image.removeAttribute('srcset');
        image.src = url;
        this.querySelectorAll('.tf-thumb').forEach(t => t.setAttribute('aria-pressed', String(t.dataset.image === url)));
      };
      this.querySelectorAll('.tf-thumb').forEach(t => t.addEventListener('click', () => changeImage(t.dataset.image)));
      const form = this.querySelector('.tf-form');
      if (!form) return;
      const feedback = this.querySelector('.tf-feedback');
      const button = this.querySelector('.tf-submit');
      form.addEventListener('change', event => {
        if (event.target.name !== 'id') return;
        const input = event.target;
        this.querySelector('.tf-price').textContent = input.dataset.price;
        this.querySelector('.tf-bar-price').textContent = input.dataset.price;
        const compare = this.querySelector('.tf-compare');
        compare.textContent = input.dataset.compare;
        compare.hidden = !input.dataset.compare;
        changeImage(input.dataset.image);
        feedback.textContent = '';
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.firstElementChild.textContent = 'Hozzáadás…';
        feedback.textContent = '';
        try {
          const response = await fetch(this.dataset.add, {method: 'POST', body: new FormData(form), headers: {Accept: 'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'A termék nem adható a kosárhoz. Kérjük, próbáld újra.');
          window.location.assign(this.dataset.cart);
        } catch (error) {
          feedback.textContent = error.message || 'Nem sikerült a hozzáadás. Próbáld újra.';
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.firstElementChild.textContent = 'Kosárba teszem';
        }
      });
      const cookiePanel = document.querySelector('#shopify-pc__banner');
      if (cookiePanel) {
        const bar = this.querySelector('.tf-mobile-bar');
        const sync = () => { bar.style.visibility = cookiePanel.getBoundingClientRect().height > 0 ? 'hidden' : ''; };
        this.cookieObserver = new MutationObserver(sync);
        this.cookieObserver.observe(cookiePanel, {attributes:true,childList:true,subtree:true});
        sync();
      }
    }
    disconnectedCallback() { if (this.cookieObserver) this.cookieObserver.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
